import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const DeliveryHubSettingsComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="P2P"
                            name="P2P"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'DeliveryHubSettings.P2P',
                                    selectLogisticsSettings?.DeliveryHubSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.DeliveryHubSettings?.P2P}
                        />
                        <InputContainer
                            label="P2H2P"
                            name="P2H2P"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'DeliveryHubSettings.P2H2P',
                                    selectLogisticsSettings?.DeliveryHubSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.DeliveryHubSettings?.P2H2P}
                        />

                    </div>
                }
                expandedPanel="DeliveryHub Settings"
                headerTitle="DeliveryHub Settings"
            />
        </>
    )
}
export default DeliveryHubSettingsComponent;
